"use client";
import { usePathname } from "next/navigation";
import React from "react";

import HowItWorkIntlSection from "../../components/Organisms/HowItWorkIntlSection";
import HowWeWorkSection from "../../components/Organisms/HowWeWorkSection/HowWeWorkSection";
import useStore from "../../lib/Store/useStore";

const ClientRender = ({ slice }) => {
    const { flag } = useStore();
    const pathname = usePathname();

    let renderSection = null;

    switch (slice?.variation) {
        case "default":
            if (flag === "AE" || pathname === "/sa-how-it-works/") {
                renderSection = <HowWeWorkSection slice={slice} />;
            }
            break;

        case "internationalization":
            if (flag !== "AE") {
                renderSection = <HowItWorkIntlSection slice={slice} />;
            }
            break;
        default:
            renderSection = null;
    }

    if (!renderSection) return <></>;
    return renderSection;
};

export default ClientRender;
